
  export default {
    props: {
      img: {
        type: String,
        default: ''
      },
      text: {
        type: String,
        default: ''

    },
    link:{
      type: String,
      default:'#'
    },
      linkText:{
      type: String,
      default:''
    },
    hide:{
      type: Boolean,
      default: false
    },
    removePadding:{
      type: Boolean,
      default: false
    }
  }
}

